/*
 * IMPORTS
 */
import React from 'react' // Npm: react.js library.
import PropTypes from 'prop-types' // Npm: react.js library.
import { connect } from 'react-redux' // Npm: React Redux for state management.
import { useHistory } from 'react-router-dom' // Npm: React router dom.
import { HiChevronUpDown, HiCreditCard, HiDocumentText, HiLockClosed, HiOutlineArrowRightStartOnRectangle, HiPencil, HiServerStack, HiTrash } from 'react-icons/hi2' // Npm: React icons.
import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal
} from '@chakra-ui/react' // Npm: Chakra UI components.

/*
 * OBJECTS
 */
const Index = ({
  vendorId,
  currency,
  onVendorUpdate,
  onVendorDelete,
  onBilateralRelationAttach,
  onVendorPasswordChange,
  PassOnUpdate
}) => {
  // Hook assignment.
  const _historyRef = useHistory()

  // Return component.
  return (
    <Menu placement='left'>
      <MenuButton
        as={Button}
        margin='auto'
        borderRadius='8px'
        color='gray.500'
        bg='transparent'>
        <HiPencil size={18} />
      </MenuButton>

      <Portal>
        <MenuList
          className='dropDownMenu'
          maxHeight='350px'
          overflow='auto'
          bg='white'
        >
          <MenuItem
            gap='12px'
            display='flex'
            pl='20px'
            pr='20px'
            color='gray.500'
            onClick={() => {
              PassOnUpdate({ vendorId })
              onVendorUpdate()
            }}
            minH='40px'>
            <HiPencil size={18} />
            <span>Edit Vendor</span>
          </MenuItem>

          <MenuItem
            gap='12px'
            display='flex'
            pl='20px'
            pr='20px'
            color='gray.500'
            onClick={() => {
              PassOnUpdate({ vendorId })
              onVendorDelete()
            }}
            minH='40px'>
            <HiTrash />
            <span>Delete Vendor</span>
          </MenuItem>

          <MenuItem
            gap='12px'
            display='flex'
            pl='17.5px'
            pr='20px'
            color='gray.500'
            onClick={() => {
              PassOnUpdate({ vendorId })
              onBilateralRelationAttach()
            }}
            minH='40px'>
            <HiChevronUpDown size={21} />
            <span>Bilateral Relation</span>
          </MenuItem>

          <MenuItem
            gap='12px'
            display='flex'
            pl='17.5px'
            pr='20px'
            color='gray.500'
            onClick={() => {
              PassOnUpdate({ vendorId })
              _historyRef.push('/vendor/report')
            }}
            minH='40px'>
            <HiOutlineArrowRightStartOnRectangle size={21} />
            <span>Vendor Panel</span>
          </MenuItem>

          <MenuItem
            onClick={() => {
              PassOnUpdate({ vendorId })
              _historyRef.push('/vendor/smpp')
            }}
            gap='12px'
            display='flex'
            pl='20px'
            pr='20px'
            color='gray.500'
            minH='40px'>
            <HiServerStack size={18} />
            <span>Manage Vendor Accounts</span>
          </MenuItem>

          <MenuItem
            gap='12px'
            display='flex'
            pl='20px'
            pr='20px'
            color='gray.500'
            onClick={() => {
              PassOnUpdate({ vendorId, currency })
              _historyRef.push('/vendor/payment')
            }}
            minH='40px'>
            <HiCreditCard />
            <span>Manage Payments</span>
          </MenuItem>

          <MenuItem
            gap='12px'
            display='flex'
            pl='20px'
            pr='20px'
            color='gray.500'
            onClick={() => {
              PassOnUpdate({ vendorId })
              onVendorPasswordChange()
            }}
            minH='40px'>
            <HiLockClosed size={18} />
            <span>Change Password</span>
          </MenuItem>

          <MenuItem
            gap='12px'
            display='flex'
            pl='20px'
            pr='20px'
            color='gray.500'
            onClick={() => {
              PassOnUpdate({ vendorId, currency })
              _historyRef.push('/vendor/invoice')
            }}
            minH='40px'>
            <HiDocumentText />
            <span>Manage Invoices</span>
          </MenuItem>
        </MenuList>
      </Portal>
    </Menu>
  )
}

/*
 * PROPTYPES
 */
Index.propTypes = {
  'onVendorUpdate': PropTypes.func,
  'onVendorDelete': PropTypes.func,
  'vendorId': PropTypes.string,
  'currency': PropTypes.string,
  'PassOnUpdate': PropTypes.func,
  'onBilateralRelationAttach': PropTypes.func,
  'onCreditManagementUpsert': PropTypes.func,
  'onVendorPasswordChange': PropTypes.func
}

/*
 * REDUX
 */
const _MapDispatchToProps = __dispatch => ({
  'PassOnUpdate': u => __dispatch({ 'type': 'PASS_ON_UPDATE', 'PassOn': u })
})

/*
 * EXPORT
 */
export default connect(void 0, _MapDispatchToProps)(Index)
